import {Cover} from "./Cover";
import {Body} from "./Body";
import {DataObject} from "./DataObject";
import {Book} from "./Book";
import {Draft} from "./Draft";

export class Project implements DataObject {
  ID: number;
  org_ID: number;
  name: string;
  primaryBook_ID: number;
  primaryDraft_ID: number;
  created: Date;
  lastUpdate: Date;
  archived: string;

  /**
   * How this Project's membership was arrived at, and whether the
   * server-side reconciler is still allowed to change it.
   *
   * `'EDITED'` / `'CONFIRMED'` / `'REJECTED'` are terminal: a human has
   * looked at the Project, so the reconciler never re-decides its membership
   * or its primary again.
   *
   * **Optional on purpose.** This belongs to the Project-backfill work the
   * server has not shipped yet, so today `GET /project` does not send it and
   * `update()` - which only copies properties present on the incoming object
   * - leaves it `undefined`. Callers MUST treat `undefined` as "the server
   * does not support this yet" and write nothing, rather than seeding a
   * value the server would not understand. It starts working on its own once
   * the server begins sending the field.
   */
  mappingStatus?: string;

  books: Book[];
  drafts: Draft[];

  primaryBook: Book;
  primaryDraft: Draft;

  folder: string;

  constructor (obj) {
    this.ID = 0;
    this.org_ID = 0;
    this.primaryBook_ID = 0;
    this.primaryDraft_ID = 0;
    this.lastUpdate = new Date(0);
    this.archived = 'FALSE';

    this.primaryBook = undefined;
    this.primaryDraft = undefined;

    this.folder = '';

    if ( obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);
  }

  getId() {
    return this.ID;
  }

  getOrderValue() {
    return this.ID;
  }

  update (obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && ( typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date )) {
          this[prop] = obj[prop];
        }
      }
    }
  }
}
